"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoAvailabilityMessage = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const utils_1 = require("../lib/utils");
const messages_1 = require("../lib/messages");
const styles_1 = require("./styles");
const styles_2 = require("../styles");
exports.NoAvailabilityMessage = (0, intl_1.injectIntl)(({ date, intl }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        date && react_1.default.createElement(styles_2.DateHeading, null, (0, utils_1.formatDateForHeading)(date)),
        react_1.default.createElement(styles_1.NoAvailabilityContainer, null,
            react_1.default.createElement(styles_1.NoAvailabilityText, null, intl.formatMessage(messages_1.messages.noAppointmentsAvailable)))));
});
//# sourceMappingURL=NoAvailabilityMessage.js.map